import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';

import { ButtonBase, Typography } from '@material-ui/core';

import * as PreviewStore from '../../../app/store/PreviewStore';
import { CommentIcon } from '../../../common/icons';


const styles = theme => ({
    root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        zIndex: 101,
        background: `${theme.palette.grey[300]}aa`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

function AddCommentOverlay({
    classes, translate, className, taskId, elementId, startComment, enableComments,
}) {
    if (!enableComments) {
        return null;
    }
    const onClick = () => {
        startComment({ taskId, elementId });
    };

    return (
        <ButtonBase onClick={onClick} className={classnames(classes.root, className)}>
            <CommentIcon color="primary" />
            <Typography>
                {translate('taskCommenting.addComment')}
            </Typography>
        </ButtonBase>
    );
}

AddCommentOverlay.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    taskId: PropTypes.string.isRequired,
    elementId: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    startComment: PropTypes.func.isRequired,
    enableComments: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    enableComments: state.previewStore.showComments,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PreviewStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddCommentOverlay));
